export default "__VITE_ASSET__c32d9d89__"